<template>
    <!-- 个人推荐 -->
      <div class="container">
          <div class="card-container">
              <el-card class="item-container" v-for="item in listArr" :key="item.title">
                  <div class="item-card" @click="openDialog(item)">
                      <div class="img-container">
                          <img :src="item.cover"/>
                      </div>
                      <div class="text-container">
                          <div class="title">{{ item.name }}</div>
                          <div class="tag" v-show="item.is_commented">已评</div>
                      </div>
                  </div>
              </el-card>
          </div>
          <Pagination :total="total" :pageSize="pageSize" :current="current" @changePagen="changePagen" @pageSizen="changePageSizen"></Pagination>
          <RecommendDetails 
            :from="from" 
            :PersonId="PersonId"  :id="id"
            :dialogVisible="dialogVisible" 
            @changeDialogVisible="changevisible" 
            :title="title" :emotion="emotion" :parentEmotion="parentEmotion"
            :studyDuration="studyDuration" :studyEmotion="studyEmotion" :studyReport="studyReport"
            :leaderEmotion="leaderEmotion">
          </RecommendDetails>
      </div>
  </template>
  <script>
  import Pagination from '../pagination.vue'
  import RecommendDetails from './RecommendDetails.vue'
  import { ResourceDetail } from '../../api/studentApi'
  
  export default {
    name: "CourseList",
    props:{
        // 父组件
        from:{
            type: String,
            default: ''
        },
        PersonId:{
            type: String,
            default: ''
        },
        // 列表数据
        listArr:{
          type: Array,
          default: ()=>[]
        },
        P_pageNum:{
          type: Number,
          default: 1
        },
        P_pageSize:{
          type: Number,
          default: 10
        },
        P_total:{
          type: Number,
          default: 100
        }
    },
    data() {
      return {
        dialogVisible: false,

        // 要传给弹框的标题和感受
        title: '',
        emotion:'',
        parentEmotion:'', // 家长心得
        studyDuration: '', // 学习时长
        studyEmotion:'',  // 学习感悟
        studyReport:'', // 学习报告
        leaderEmotion:'',  // 校长心得

        // 详情页需要的课程id
        id:0,

        current:1,
        pageSize:10,
        total:0
      };
    },
    watch:{
      P_pageNum(newVal){
        this.current = newVal
      },
      P_pageSize(newVal){
        this.pageSize = newVal
      },
      P_total(newVal){
        this.total = newVal
      },
    },
    methods: {
      openDialog(item){
        // debugger
        this.title = item.title
        this.emotion = item.emotion
        this.parentEmotion = item.parentEmotion
        this.studyDuration = item.studyDuration
        this.studyEmotion = item.studyEmotion
        this.studyReport = item.studyReport
        this.leaderEmotion = item.leaderEmotion
        this.id = item.id
        this.dialogVisible = true
      },
      changevisible(value){
        this.dialogVisible = value
      },
      changePagen(val) {
          this.current = val;
          this.$emit('changePage', val)
      },
      changePageSizen(val) {
          this.pageSize = val;
          this.$emit('pageSize', val)
      },
    },
    components:{
      Pagination,
      RecommendDetails
    }
  };
  </script>
  <style lang="less" scoped>
  .card-container {
    height: 2.7778rem;
      margin-bottom: .2847rem;
      display: flex;
      flex-wrap: wrap;
    .item-container {
      margin-right: .0486rem;
      margin-bottom: .1528rem;
      width: 1.5972rem;
      height: 1.2569rem;
      border-radius: 0.0208rem;
      cursor: pointer;
      /deep/ .el-card__body {
        padding: 0rem;
      }
      .img-container {
        img {
          width: 1.5972rem;
          height: 0.8333rem;
        }
      }
      .text-container {
        padding: 0rem 0.0694rem 0.0556rem 0.0694rem;
        box-sizing: border-box;
        .title {
          font-size: 0.0972rem;
          color: #080808;
          font-weight: bold;
        }
        .tag {
          margin-top: .0347rem;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 0.2778rem;
          height: 0.1389rem;
          color: #b7bdc3;
          font-size: 0.0833rem;
          border: 1px solid #b7bdc3;
          border-radius: 0.0208rem;
        }
      }
    }
  }
  </style>


// WEBPACK FOOTER //
// src/components/reuse/CourseList.vue